module.exports = __webpack_public_path__ + "static/media/sound-latigo.0081cc77.mp3";